import { configureAuth } from '@envision/ev-ui-component-library'
import type { AppConfig } from './types'

/**
 * One-time auth singleton setup. Call after runtime config is loaded.
 */
export function initAuth(cfg: AppConfig): void {
  const encryptionSecret = process.env.REACT_APP_ENCRYPTION_KEY
  if (!encryptionSecret) {
    throw new Error(
      'REACT_APP_ENCRYPTION_KEY is required for auth token encryption'
    )
  }

  if (!cfg.authorizationServiceBaseUrl) {
    throw new Error('REACT_APP_AUTHORIZATION_BASE_URL is required for auth')
  }

  if (!cfg.universLoginPage) {
    throw new Error('REACT_APP_UNIVERS_LOGIN_PAGE is required for auth')
  }

  configureAuth({
    authBaseUrl: cfg.authorizationServiceBaseUrl,
    encryptionSecret,
    loginPageUrl: cfg.universLoginPage,
    storageKey: cfg.authStorageKey || 'auth',
    authCookieName: cfg.authCookieName || 'Auth',
    ssoCookieName: cfg.ssoCookieName || 'univers_sso_token',
    parentDomain: cfg.authParentDomain || 'univers.de',
    onAuthFailure: () => {
      if (typeof window !== 'undefined' && cfg.universLoginPage) {
        window.location.replace(cfg.universLoginPage)
      }
    },
  })
}
